/*
 * @Descripttion: 
 * @version: 
 * @Author: gaolongzhi
 * @Date: 2020-04-01 11:29:10
 * @LastEditors: gaolongzhi
 * @LastEditTime: 2020-05-08 15:42:38
 */

//清除；浏览器缓存
function clearCookie(cookieName) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = getCookie(cookieName);
    if (cval != null) {
        document.cookie = cookieName + "=" + cval + ";expires=" + exp.toGMTString();
    }
}
//获取cookie
function getCookie(name) 
{ 
    var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)"); 
　　 return (arr=document.cookie.match(reg))?unescape(arr[2]):null;
}

export { clearCookie }